/* eslint-disable no-empty */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import $axios from './index';


// Create (POST)
export const createData = createAsyncThunk('create data', async (newData) => {
  const response = await $axios.post('/products', newData);
  return response.data;
});

// Read (GET)

export const fetchData = createAsyncThunk(
  'products/fetchData',
  async ({ page = 1, limit = 12 }) => {
    const response = await $axios.get(`/products?page=${page}&limit=${limit}`);
    return response.data; 
  }
);

// Banner Size Charts (GET)
export const fetchBannerSizeChartsData = createAsyncThunk('get size chart data', async (id) => {
  const response = await $axios.get(`/banners?type=sizechart`);
  return response.data;
});

// Single data (GET)
export const fetchSingleData = createAsyncThunk('get single data', async (id) => {
  const response = await $axios.get(`/products/${id}`);

  return response.data.data;
});


// Get Last Product ID (GET)
export const fetchLastId = createAsyncThunk(
  "products/fetchLastId",
  async () => {
    const response = await $axios.get("/products/last-id");
    return response.data; 
  }
);

// Update (PUT or PATCH)
export const updateData = createAsyncThunk('update data', async ({ id, updatedData }) => {
  const response = await $axios.put(`/products/${id}`, updatedData);
  return response.data;
});

// Delete (DELETE)
export const deleteData = createAsyncThunk('delete data', async (id) => {
  await $axios.delete(`/products/${id}`);
  return id;
});



export const resetDataProductSlice = createAsyncThunk('reset data', async () => {
  return 'reset data';
});

// Slice
const productSlice = createSlice({
  name: 'productSlice',
  initialState: {
    data: [],
    sizeCharts: [],
    newProduct: null,
    newProductError: false,
    singleProduct: null,
    singleProductError: false,
    updatedProduct: null,
    updatedProductError: false,
    loading: false,
    error: null,
  lastId: null,
  lastIdError: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    // Fetch Data
    builder
      .addCase(fetchData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });

    builder.addCase(resetDataProductSlice.fulfilled, (state, action) => {
      state.data = [];
      state.newProduct = null;
      state.newProductError = false;
      state.singleProduct = null;
      state.singleProductError = false;
      state.updatedProduct = null;
      state.updatedProductError = false;
      state.loading = false;
      state.error = null;
    });

    // Fetch Single Data
    builder
      .addCase(fetchSingleData.pending, (state) => {
        state.singleProductError = false;
        state.loading = true;
        state.singleProduct = null;
      })
      .addCase(fetchSingleData.fulfilled, (state, action) => {
        state.loading = false;
        state.singleProduct = action.payload;
        
      })
      .addCase(fetchSingleData.rejected, (state, action) => {
        state.loading = false;
        state.singleProduct = null;
        state.singleProductError = action.error;
      });

    // Create Data
    builder
    .addCase(createData.pending, (state, action) => {
      state.newProductError = false;
      state.newProduct  = null;
    })
    .addCase(createData.fulfilled, (state, action) => {
      state.newProduct  = action.payload;
    })
    .addCase(createData.rejected, (state, action) => {
      state.newProduct = null;
      state.newProductError = true;
    });

// Fetch LastId
builder
  .addCase(fetchLastId.pending, (state) => {
    state.lastIdError = false;
    state.lastId = null;
  })
  .addCase(fetchLastId.fulfilled, (state, action) => {
    const lastId = action.payload.productId; 
    const randomString = Date.now().toString(36).substring(0, 5); 
    if (lastId) {
      
      const numberPart = parseInt(lastId.replace(/\D/g, ""), 10) || 0; 
      state.lastId = `SKU${numberPart + 1}_${randomString}`; 
    } else {
      state.lastId = `SKU1_${randomString}`;
    }
  })
  .addCase(fetchLastId.rejected, (state) => {
    const randomString = Date.now().toString(36).substring(0, 5);
    state.lastId = `SKU1_${randomString}`; 
    state.lastIdError = true;
  });


    // Update Data
    builder
    .addCase(updateData.pending, (state) => {
      state.updatedProductError = false;
      state.loading = true;
      state.updatedProduct = null;
    })
    .addCase(updateData.fulfilled, (state, action) => {
      state.loading = false;
      state.updatedProduct = action.payload.data;
    })
    .addCase(updateData.rejected, (state, action) => {
      state.loading = false;
      state.updatedProduct = null;
      state.updatedProductError = action.error;
    });

    // Delete Data
    builder.addCase(deleteData.fulfilled, (state, action) => {
      if (Array.isArray(state.data)) {
    state.data = state.data.filter(item => item._id !== action.payload);
  }
    });

    builder
    .addCase(fetchBannerSizeChartsData.pending, (state) => {
      state.sizeCharts = [];
    })
    .addCase(fetchBannerSizeChartsData.fulfilled, (state, action) => {
      const { data } = action.payload;
      if (data?.length) {
        state.sizeCharts = data;
      } else {
      
        state.sizeCharts = [];
      }
    })
    .addCase(fetchBannerSizeChartsData.rejected, (state, action) => {
      state.sizeCharts = [];
    });
  },
});

export default productSlice.reducer;
